import { render, staticRenderFns } from "./GroupsAll.vue?vue&type=template&id=6b35a6f7&scoped=true&"
import script from "./GroupsAll.vue?vue&type=script&lang=js&"
export * from "./GroupsAll.vue?vue&type=script&lang=js&"
import style0 from "./GroupsAll.vue?vue&type=style&index=0&id=6b35a6f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35a6f7",
  null
  
)

export default component.exports